import pb from '../lib/pocketbase';

export async function getCategorias(page, perPage) {
  return await pb.collection('categoria').getList(page, perPage, {
    sort: '-created', // Ordenar por fecha de creación descendente
    $autoCancel: false,
    expand: 'parent' // Expandir relación con categoría padre
  });
}

export async function createCategoria(categoria) {
  return await pb.collection('categoria').create(categoria);
}

export async function updateCategoria(id, categoria) {
  return await pb.collection('categoria').update(id, categoria);
}

export async function deleteCategoria(id) {
  return await pb.collection('categoria').delete(id);
}

export async function getCategoriaById(id) {
  return await pb.collection('categoria').getOne(id, {
    expand: 'parent'
  });
}

export async function getCategoriasByParent(parentId, page, perPage) {
  return await pb.collection('categoria').getList(page, perPage, {
    filter: `parent = "${parentId}"`,
    sort: 'descrip',
    $autoCancel: false,
    expand: 'parent'
  });
}

export async function getRootCategorias(page, perPage) {
  return await pb.collection('categoria').getList(page, perPage, {
    filter: 'parent = ""',
    sort: 'descrip',
    $autoCancel: false
  });
}
